// extracted by mini-css-extract-plugin
export var progressCircle = "uploader-module--progressCircle--7fv8h";
export var dragDrop = "uploader-module--dragDrop--2le3v";
export var dragOver = "uploader-module--dragOver--2ebhK";
export var hiddenProgress = "uploader-module--hiddenProgress--kxYLk";
export var sendBtnCol = "uploader-module--sendBtnCol--35Ulf";